import { Link, useParams } from "react-router-dom";
import { Button, ErrorText, Panel, Spinner } from "../../components/ui";
import { fmtAmount, fmtDate, fmtPrice } from "../../lib/format";
import { useCancelTransaction, useTransactions } from "./hooks";
import type { Transaction } from "./api";

const TYPE_LABEL: Record<Transaction["type"], string> = {
  buy: "Achat",
  sell: "Vente",
  dividend: "Dividende",
  deposit: "Dépôt",
  withdrawal: "Retrait",
  fee: "Frais",
  split: "Split",
};

export function TransactionsPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useTransactions(id);
  const cancel = useCancelTransaction(id as string);

  return (
    <Panel
      title="Transactions"
      actions={
        <Link to={`/portfolios/${id}/transactions/new`}>
          <Button>+ Transaction</Button>
        </Link>
      }
    >
      <ErrorText error={error} />
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Qté @ Prix</th>
                <th>Frais</th>
                <th>Effet cash</th>
                <th>Statut</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data?.map((t) => (
                <tr key={t.id}>
                  <td>{fmtDate(t.tradeDate)}</td>
                  <td>{TYPE_LABEL[t.type]}</td>
                  <td>
                    {fmtAmount(t.quantity)} @ {fmtPrice(t.unitPrice)}
                  </td>
                  <td>{fmtAmount(t.totalFees)}</td>
                  <td>{fmtAmount(t.cashEffect)}</td>
                  <td>{t.status}</td>
                  <td>
                    {t.status === "confirmed" && (
                      <Button
                        variant="danger"
                        disabled={cancel.isPending}
                        onClick={() => {
                          if (confirm("Annuler cette transaction ?")) cancel.mutate(t.id);
                        }}
                      >
                        Annuler
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
              {data?.length === 0 && (
                <tr>
                  <td colSpan={7} className="muted">
                    Aucune transaction.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
